// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Choose a theme',
  dark: 'Dark',
  light: 'Light',
} as ILanguage;
